import { render, staticRenderFns } from "./DeleteAccountModal.vue?vue&type=template&id=14b21d08&scoped=true&"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b21d08",
  null
  
)

export default component.exports